module.exports = __webpack_public_path__ + "img/dryness.521b5818.png";